<template>
  <div class="bottom-photo-toast" :class="fromType">
    <div class="mask" @click="handleClose"></div>
    <div class="toast-header">
      <div class="close-btn" @click="handleClose"></div>
    </div>
    <div class="toast-content" :style="{ backgroundImage: `url(${backgroundImg})` }">
      <div v-if="isShowAvatar"
          class="avatar-wrap"
        >
        <img
          class="avatar"
          :src="user_img || 'https://qncweb-back1.ktvsky.com/20230111/other/b111d8fb43bb9eee0ff9ecd66fe1d32d.png'"
          alt="头像"
        >
      </div>
      <div class="photo-container">
        <div class="photo-container-inner" :class="uploadedPics.length > 2 && 'photos-centered'">
          <div class="photo-list" v-if="uploadedPics.length > 0">
            <div class="photo-item" v-for="(pic, index) in uploadedPics" :key="index">
              <div class="remove-icon" @click="deletePhoto(index)"></div>
              <div class="photo-preview" :style="`background-image: url(${pic});`"></div>
            </div>
          </div>
          <div class="photo-upload" v-if="uploadedPics.length < imgnum" @click="uploadPhoto">
            <div class="upload-icon"></div>
            <p>上传照片({{uploadedPics.length}}/{{imgnum}})</p>
            <span class="notification-dot"></span>
          </div>
        </div>
      </div>

      <div class="bottom-section">
        <template v-if="!hasPrivilege">
          <div class="price-tag"><span v-if="isShowXS">限时</span>￥{{parentParams.price/100}}</div>
        </template>
        <button class="send-btn"
                @click="handleSendPhoto">
          发送上屏
        </button>
        <div class="cursor">
          <img src="https://qncweb-back1.ktvsky.com/20220818/other/9f00502bfc1234a0b29d6f097f691652.png">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import sendPhoto from '@/mixins/send_photo';

export default {
  name: 'BottomPhotoToast',
  mixins: [sendPhoto],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    fromType: {
      type: String,
      default: ''
    },
    backgroundImg: {
      type: String,
      default: ''
    },
    isShowAvatar: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadedPics: [],
      hasPrivilege: false,
      parentParams: {},
      entrance: 'photoBT_ordered',
      isLoading: true,
    };
  },
  computed: {
    ...mapState({
      openid: (state) => state.openid,
      unionid: (state) => state.unionid,
      photoPag: (state) => state.photoPag,
      photoPath: (state) => state.photoPath,
      role: (state) => state.role,
      user_img: (state) => state.user_img,
    }),
    imgnum() {
      return this.photoPath.id === 1 ? 1 : 6;
    },
    isShowXS() {
      return ['photoT_searchResultAd', 'photoT_orderedSong_1', 'photoT_homeAvatar'].includes(this.fromType)
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const files = Array.from(event.target.files);
      const remainingSlots = this.imgnum - this.uploadedPics.length;
      const filesToProcess = files.slice(0, remainingSlots);

      filesToProcess.forEach((file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedPics.push(e.target.result);
        };
        reader.readAsDataURL(file);
      });
    },
    deletePhoto(index) {
      this.uploadedPics.splice(index, 1);
    },
    handleSendPhoto() {
      this.$sendLog({
        event_type: 'click',
        event_name: '发照片弹窗-点击',
        event_data: {
          fromType: this.fromType,
          name: this.photoPath.label,
          role: this.role
        }
      })
      if (this.hasPrivilege || !this.isLoading) {
        this.$sendLog({
          event_type: 'click',
          event_name: '发照片弹窗-点击发送',
          event_data: {
            fromType: this.fromType,
            name: this.photoPath.label,
            role: this.role
          }
        })
      }
      this.handleSend(this.entrance)
    },
  },
  mounted() {
    // 检查权限
    this.getDefault();
    // 发送展示日志
    this.$sendLog({
      event_type: 'click',
      event_name: '发照片弹窗-展示',
      event_data: {
        fromType: this.fromType,
        name: this.photoPath.label,
        role: this.role
      }
    })

    this.entrance = `${this.fromType}_${this.photoPath.entrance}`
  }
};
</script>

<style lang="scss" scoped>
.bottom-photo-toast {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;

  .mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
  }

  .toast-content {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 659px;
    background-repeat: no-repeat;
    background-position: center bottom;
    background-size: contain;
    border-radius: 20px 20px 0 0;
    padding: 180px 30px 30px;
  }

  .toast-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 30px;

    .close-btn {
      position: absolute;
      top: 50px;
      right: 30px;
      width: 60px;
      height: 60px;
      background: url('https://qncweb-back1.ktvsky.com/20240912/vadd/2ea871a7ae89d3ddf55722505052ff2f.png') no-repeat center;
      background-size: contain;
    }
  }

  .photo-container {
    width: 690px;
    height: 237px;
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    margin: 35px auto 50px;
    overflow-x: scroll;
    &::-webkit-scrollbar {
      display: none;
    }
  }

  .photo-container-inner {
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    justify-content: center;
  }

  .photos-centered {
    width: fit-content;
  }

  .photo-list {
    height: 100%;
    display: flex;
    flex-wrap: nowrap;
    width: fit-content;
  }

  .photo-item {
    position: relative;
    width: 212px;
    height: 212px;
    margin: 15px 10px 0 0;
    border-radius: 30px;

    .remove-icon {
      position: absolute;
      top: -15px;
      right: 4px;
      width: 40px;
      height: 40px;
      background: url('https://qncweb.ktvsky.com/20250214/vadd/a9eb91dbebe083ff33369f85f437fefc.png') no-repeat center center;
      background-size: contain;
      z-index: 1;
      cursor: pointer;
    }

    .photo-preview {
      width: 100%;
      height: 100%;
      background-size: cover;
      border: 1px solid #fff;
      border-radius: 30px;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  .photo-upload {
    width: 212px;
    height: 212px;
    padding-top: 135px;
    color: #000;
    border-radius: 30px;
    background: #fff url('https://qncweb-back1.ktvsky.com/20240912/vadd/4c8af338357ba43fd5201659297d5ec0.png') no-repeat 66px 43px;
    background-size: 80px 80px;
    border: 1px solid #E6E6E6;
    font-size: 25px;
    text-align: center;
    margin-top: 15px;
    position: relative;

    .notification-dot {
      position: absolute;
      top: 45px;
      right: 65px;
      width: 15px;
      height: 15px;
      background-color: #FF334E;
      border-radius: 50%;
      display: inline-block;
    }
  }

  .bottom-section {
    position: relative;
    display: flex;
    justify-content: center;

    .price-tag {
      position: absolute;
      top: -30px;
      left: 430px;
      background: #FF334E;
      color: #fff;
      padding: 3px 10px;
      border-radius: 15px 15px 15px 0;
      font-size: 24px;
    }

    .send-btn {
      width: 618px;
      height: 90px;
      background: linear-gradient(180deg, #FF21D3 0%, #FF7CBC 100%);
      border-radius: 45px;
      color: #FFFC12;
      font-size: 35px;
      font-weight: bold;
      border: none;
    }
  }
  .cursor {
    width: 100px;
    position: absolute;
    right: 50px;
    bottom: -20px;
    animation: shakeX 2.5s linear 0s infinite normal;
    animation-fill-mode: both;
  }
}
.avatar-wrap {
  position: absolute;
  top: 54px;
  left: 75px;
  img {
    width: 66px;
    height: 66px;
    border-radius: 50%;
  }
}
.photoT_searchResultAd,.photoT_orderedSong_1,.photoT_homeAvatar{
  .bottom-section {
    .send-btn {
      background: #FFC43D;
      color: #000000;
      font-size: 45px;
    }
  }
}
.photoT_homeAvatar {
  .toast-content {
    height: 890px;
    padding: 400px 30px 30px;
  }
  .avatar-wrap {
    position: absolute;
    top: 280px;
    left: 50px;
  }
  .bottom-section {
    .send-btn {
      background: linear-gradient(180deg, #FFEC59 0%, #FFD321 100%);
      color: #341B01;
      font-size: 45px;
    }
  }
}
</style>
